<template>
  <el-dialog width="420px" class="dialogClass" title="" :before-close="handleClickCancel" :close-on-press-escape="false"
             :close-on-click-modal="false" :visible.sync="joinEnterpriseVisible">
    <div class="details">
      <div class="dialogTilte">加入企业</div>
      <div class="mb-16">
        <el-steps :active="activeStep" align-center>
          <el-step title="输入邀请码" description=""></el-step>
          <el-step title="填写个人信息" description=""></el-step>
        </el-steps>
      </div>
      <div class="join_enterprise_padding">
       <el-form    ref="currencyForm"   v-loading="loading"    label-position="right"   label-width="110px"  :model="currencyForm"  :rules="currencyFormRules">
        <el-form-item label="邀请码" prop="code" v-if="activeStep == 1">
          <el-input type="text" v-model="currencyForm.code" placeholder="请输入邀请码"></el-input>
        </el-form-item>

        <div class="ta-c company"  v-if="activeStep == 2">
          ********公司
        </div>
        <el-form-item label="姓名" prop="name" v-if="activeStep == 2">
          <el-input type="text" v-model="currencyForm.name" placeholder="请输入姓名"></el-input>
        </el-form-item>

        <el-form-item label="加入原因" prop="name" v-if="activeStep == 2">
          <el-input type="textarea" v-model="currencyForm.name" placeholder="请输入加入原因"></el-input>
        </el-form-item>

      </el-form>
      </div>
    </div>
    <div slot="footer">
      <el-button  :disabled="BtnDisabled" @click="handleClickCancel">取消</el-button>
      <el-button  type="primary" v-if="activeStep == 1" :disabled="BtnDisabled" @click="handleClickNext">下一步</el-button>
      <el-button  type="primary" v-if="activeStep == 2":disabled="BtnDisabled" @click="handleClickConfirm">确认加入</el-button>
    </div>
  </el-dialog>
</template>
<script>

import { } from '@/api/api'
import { uploadImg ,getOSSData} from '@/utils/uploadOss'
import {mapState} from "vuex";
import {industryList} from '@/mixins'
export default {
  name: 'join_enterprise',
  props: {
    joinEnterpriseVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {

    return {
      loading:false,
      BtnDisabled: false,
      activeStep:1,
      currencyForm:{
        code:'',
      },
      currencyFormRules:{
        code:[{ required: true, message: '请输入邀请码', trigger: 'blur'}],
      },


    }
  },
  mixins: [industryList],
  created() {

  },
  computed: {
    ...mapState(['webUserInfo']),
  },
  mounted() {

  },
  methods: {

    handleClickNext(){
      this.activeStep = 2
    },
    handleClickConfirm(){
      this.$refs.currencyForm.validate(valid => {
        if (valid) {
          // let postDataInfo = {
          //   file:this.currencyForm.file
          // }
          // this.BtnDisabled = true
          // clipUpload(postDataInfo).then(res => {
          //   if (res.code === 0) {
          //     this.$message({
          //       message: '新增成功',
          //       type: 'success',
          //       duration: 1000,
          //       onClose: () => {
          //         this.BtnDisabled = false
          //         this.$emit('success')
          //         this.$emit('update:joinEnterpriseVisible', false)
          //       }
          //     })
          //   }else{
          //     this.BtnDisabled = false
          //   }
          // }).catch((e) => {
          //   this.BtnDisabled = false
          // })
        }
      })
    },


    //取消事件
    handleClickCancel() {
      //关闭对话框
      this.$emit('update:joinEnterpriseVisible', false)
    },


  },

}
</script>
<style lang="scss" scoped>
p {
  margin: 0;
  padding: 0;
}
.mt-15{
  margin-top: 15px;
}
.el-select{
  display: block;
}
.company{
  line-height: 22px;
  margin-bottom: 18px;
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
}
.join_enterprise_padding{
  padding: 24px 0 24px;
}
</style>
